import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ECollection } from '../enums/ECollection';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { UtilsService } from './utils.service';
import { BaseService } from './base-service';
import { EModelApiPaths } from '../enums/EModelApiPaths';

@Injectable({
  providedIn: 'root'
})
export class Searchservice extends BaseService {
  constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService,
                public authService: AuthService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.SW_BRAND}`);
    }


    async searchQuery<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.SEARCH_QUERY, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }
}
